import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FuseConfigService } from "@fuse/services/config.service";
import { environment } from '../../../../environments/environment'

@Component({
    selector: "app-charge-history",
    templateUrl: "./charge-history.component.html",
    styleUrls: ["./charge-history.component.scss"],
})
export class ChargeHistoryComponent implements OnInit {
    user_id: any = "";
    mobile_no: any = "";
    chargeHistory: any = [];

    constructor(
        private _fuseConfigService: FuseConfigService,
        private router: Router
    ) {
        // Hide layout elements
        this._fuseConfigService.config = {
            layout: {
                navbar: { hidden: true },
                toolbar: { hidden: true },
                footer: { hidden: true },
                sidepanel: { hidden: true },
            },
        };
    }

    ngOnInit(): void {
        this.user_id = sessionStorage.getItem("web_user_id");
        this.mobile_no = sessionStorage.getItem("web_mobile");

        if (!this.user_id || !this.mobile_no) {
            this.router.navigate(["/web-login"]);
            return;
        }

        this.getTransactionHistoryByuserId();
    }

    async getTransactionHistoryByuserId() {
        const payload = {
            user_id: this.user_id,
            start_date: "",
            end_date: "",
        };
        try {
            const res = await fetch(
                // "https://cmsapi.vmatic.co.in/api-v2/app/getTransactionHistoryByuserId",
                `${environment.API_URL2}/api-v2/app/getTransactionHistoryByuserId`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                }
            );

            const result = await res.json();

            console.log("result");
            console.log(result);

            if (result.status) {
                this.chargeHistory = result.data;
            }
        } catch (err) {
            console.error("Stop charging error:", err);
        }
    }

    convertToMinutes(seconds: string | number): string {
        if (!seconds) return "0m 0s";

        const totalSeconds = Math.floor(Number(seconds));
        const minutes = Math.floor(totalSeconds / 60);
        const remainingSeconds = totalSeconds % 60;

        return `${minutes}m ${remainingSeconds}s`;
    }
}
